const selectColor: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#3A73B3",
    buttonColor: "#113C4F",
  },
  {
    color: "#7d6f7a",
    buttonColor: "#525252",
  },
  {
    color: "#7e91be",
    buttonColor: "#6a497b",
  },
  {
    color: "#C13333",
    buttonColor: "#7E2020",
  },
  {
    color: "#020029",
    buttonColor: "#1F3537",
  },
  {
    color: "#E2831D",
    buttonColor: "#A97E35",
  },
];

export default selectColor;
